module.exports = __webpack_public_path__ + "media/images/share-icon-4a730a8036d9ed182bfe1d14b21821e4.svg";